import { API_URL } from '../../../app-config/constants';
import { get } from '../request';

getRequestFeedbackTeamOverview.operation = 'READ';
getRequestFeedbackTeamOverview.idFrom = y => y.requestId;
export function getRequestFeedbackTeamOverview() {
    return get(`${API_URL}/feedback/request/overview/team`);
}
